import { init, configureScope } from '@sentry/browser';
import { CaptureConsole, ExtraErrorData } from '@sentry/integrations';
import { SENTRY_ENVIRONMENT, TRANSACTION_ID } from '@config';

function initSentry() {
  if (__PROD__ || __STAGING__) {
    init({
      dsn: 'https://024d858ba61a4dbd884b8f8b90ed3a87@sentry.io/1864487',
      integrations: [
        new CaptureConsole({
          levels: ['error'],
        }),
        new ExtraErrorData(),
      ],
      ignoreErrors: ['NotFoundError', 'ChunkLoadError', /service worker/, 'NotAllowedError', /getUserMedia/],
      environment: SENTRY_ENVIRONMENT,
    });

    configureScope(scope => {
      scope.setTag('transaction_id', TRANSACTION_ID);
      scope.setTag('network_type', navigator?.connection?.effectiveType || 'unknown');
    });
  }
}

export default initSentry;
